import React from "react";

const DailySalesPerformance = ({
    data,
    onManagerClick,
    onMTDAcquisitionClick,
    onMTDBeatPlanGTVClick,
    onBeatPlanAdherenceClick,
    onRowClickThrough,
    onTotalClickThrough
}) => {
    if (!data) return null;

    const { managers, totals } = data.data;
    const { ocrWeightage } = data;

    return (
        <div className="spd-table-container">
            <div className="table-responsive">
                <table className="table table-bordered spd-main-table">
                    <thead>
                        {/* Period Row */}
                        <tr className="spd-period-row">
                            <th rowSpan="2">Manager Name</th>
                            <th rowSpan="2">Total Allocated<br />#UTIDs</th>
                            <th rowSpan="2">#ICs</th>
                            <th colSpan="2">MTD Acquisition</th>
                            <th colSpan="4">MTD IC Composite Performance<br />(Composite of usage and acquisition targets)</th>
                            <th rowSpan="2">Lowest IC<br />Performance</th>
                            <th rowSpan="2">MTD Beat<br />Plan GTV</th>
                            <th rowSpan="2">OKR Status (%)</th>
                        </tr>
                        {/* Column Headers */}
                        <tr>
                            <th>Target</th>
                            <th>Achieved</th>
                            <th>0</th>
                            <th>&gt;0% &lt;=40%</th>
                            <th>&gt;40% &lt;=80%</th>
                            <th>&gt;80%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* OKR Weightage Row */}
                        <tr className="spd-okr-weightage-row">
                            <td><strong>OKR Weightage</strong></td>
                            <td></td>
                            <td></td>
                            <td colSpan="2"><strong>{ocrWeightage.acquisition || 'N/A'}</strong></td>
                            <td colSpan="4"></td>
                            <td><strong>{ocrWeightage.lowestIC || 'N/A'}</strong></td>
                            <td></td>
                            <td><strong>Blended %</strong></td>
                        </tr>
                        {managers.map((manager, idx) => (
                            <tr
                                key={idx}
                                className="spd-manager-row"
                            >
                                <td>
                                    <a
                                        href="#"
                                        className="spd-manager-link"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onManagerClick(manager.managerId);
                                        }}
                                    >
                                        {manager.managerName}
                                    </a>
                                </td>
                                <td className="text-center">{manager.totalAllocatedUTIDs}</td>
                                <td className="text-center">{manager.numICs}</td>
                                <td className="text-center">{manager.mtdAcquisition.target}</td>
                                <td
                                    className="text-center spd-clickable-cell"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onMTDAcquisitionClick(manager);
                                    }}
                                >
                                    {manager.mtdAcquisition.achieved}
                                </td>
                                <td className="text-center">{manager.mtdICComposite.bucket0}</td>
                                <td className="text-center">{manager.mtdICComposite.bucketUpTo40}</td>
                                <td className="text-center">{manager.mtdICComposite.bucketUpTo80}</td>
                                <td className="text-center">{manager.mtdICComposite.bucketAbove80}</td>
                                <td className="text-center">{manager.lowestICPerformance}</td>
                                <td
                                    className="text-center spd-clickable-cell"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onMTDBeatPlanGTVClick(manager);
                                    }}
                                >
                                    {manager.mtdBeatPlanGTV.achievedPercent}%
                                </td>
                                <td className="text-center">{manager.okrStatus.blendedPercent}%</td>
                            </tr>
                        ))}

                        <tr
                            className="spd-total-row"
                            onClick={() => onTotalClickThrough && onTotalClickThrough()}
                            style={{ cursor: 'pointer' }}
                        >
                            <td><strong>Total</strong></td>
                            <td className="text-center"><strong>{totals.totalAllocatedUTIDs}</strong></td>
                            <td className="text-center"><strong>{totals.numICs}</strong></td>
                            <td className="text-center"><strong>{totals.mtdAcquisition.target}</strong></td>
                            <td className="text-center"><strong>{totals.mtdAcquisition.achieved}</strong></td>
                            <td className="text-center"><strong>{totals.mtdICComposite.bucket0}</strong></td>
                            <td className="text-center"><strong>{totals.mtdICComposite.bucketUpTo40}</strong></td>
                            <td className="text-center"><strong>{totals.mtdICComposite.bucketUpTo80}</strong></td>
                            <td className="text-center"><strong>{totals.mtdICComposite.bucketAbove80}</strong></td>
                            <td className="text-center"><strong>{totals.lowestManagerPerformance}</strong></td>
                            <td className="text-center"><strong>{totals.mtdBeatPlanGTV.achievedPercent}%</strong></td>
                            <td className="text-center"><strong>{totals.okrStatus.blendedPercent}%</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mt-2 text-muted small">
                <em>Click on manager name to view IC breakdown • Click on MTD Acquisition or MTD Beat Plan GTV to view detailed reports</em>
            </div>
        </div>
    );
};

export default DailySalesPerformance;
